import React from 'react';
import './style.scss';
import cn from 'classnames';

interface ButtonProps {
  title?: string;
  type?: 'primary' | 'secondary';
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}
const Button: React.FC<ButtonProps> = ({
  title = '',
  type = 'primary',
  onClick = null,
  className = '',
  disabled = false,
}) => {

  const buttonClass = cn('button', type, className, { disabled: disabled });

  return (
    <button className={buttonClass} onClick={!disabled ? onClick : undefined} disabled={disabled}>
      {title}
    </button>
  );
};

export default Button;
